import { style } from "@vanilla-extract/css";

export const flexStyle = style({
  minWidth: "100%",
});
